import { SubSection } from "context/BlogContext";
import * as Yup from "yup";

export const paragraphInitialValues = (subSection: SubSection) => ({
  title: subSection?.title || "",
  type: subSection?.attrs?.type || "",
  text: subSection?.attrs?.text || "",
});

export const paragraphValidationSchema = Yup.object({
  type: Yup.string().required("Type is required"),
  text: Yup.string().required("Description is required"),
});
